import { ClbTable } from '@celebration/react';
import { Column } from '@celebration/react/ClbTable/ClbTable.types';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ILoadsCreationResultTableProps from './interfaces/ILoadsCreationResultTableProps';
import ILoadCreationResultTableData from '../loads-import-result/interfaces/ILoadCreationResultTableData';
import LoadsUtils from '../../utils';

function LoadCreationResultTable({
    data,
}: Readonly<ILoadsCreationResultTableProps>) {
    const { t } = useTranslation();
    const columns: Column<any>[] = [
        {
            dataIndex: 'loadId',
            title: t('FilterLoadLabelCargas'),
        },
        {
            dataIndex: 'observation',
            title: t('Observacao'),
        },
    ];

    const [resultLoadCreationData, setResultLoadCreationData] = useState<
        ILoadCreationResultTableData[]
    >([] as ILoadCreationResultTableData[]);
    const pageSize = useRef<number>(5);
    const page = useRef<number>(1);

    const itemsPerPageOptions = [5, 10, 20, 30];

    const numberOfItems = useMemo(() => {
        return data.length;
    }, [data]);

    const paginate = useCallback(
        (page: number, quantity: number): void => {
            const startItemIndex = (page - 1) * quantity;
            const endItemIndex = startItemIndex + quantity;

            setResultLoadCreationData(
                data?.slice(startItemIndex, endItemIndex),
            );
        },
        [data],
    );

    useEffect(() => {
        paginate(page.current, pageSize.current);
    }, [paginate, page, pageSize]);

    const handleNextPageFunc = useCallback(
        (newPage: number) => {
            page.current = newPage;
            paginate(page.current, pageSize.current);
        },
        [paginate, page, pageSize],
    );

    const handlePageSizeFunc = useCallback(
        (newPageSize: number) => {
            pageSize.current = newPageSize;
            paginate(page.current, pageSize.current);
        },
        [pageSize, paginate, page],
    );

    return (
        <div className="loads-import-result__container">
            <div className="loads-import-result-table__body-container">
                <div
                    className="loads-import-result-table__body"
                    data-testid="loads-import-result-table__body"
                >
                    <h1>{t('ManualLoadImportEtapa3')}</h1>
                    <p>{t('UploadCargasCargasEnviadas')}</p>
                    <div
                        className="loads-import-result-table_body-table"
                        data-testid="loads-import-result-table__body-table"
                    >
                        <ClbTable
                            columns={columns}
                            config={{
                                pagination: {
                                    page: page.current,
                                    pageSize: pageSize.current,
                                    totalItems: numberOfItems,
                                    customItemsPerPage: itemsPerPageOptions,
                                    onChangePage: handleNextPageFunc,
                                    onChangePageSize: handlePageSizeFunc,
                                    i18n: LoadsUtils.getI18nForTablePagination(
                                        t,
                                    ),
                                },
                                showFilterTags: false,
                                tableEmpty: {
                                    title: t('NaoHaDadosParaExibir'),
                                },
                            }}
                            data={resultLoadCreationData}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoadCreationResultTable;
